import { Component } from '@ecs/Component';

export class HunterAI implements Component {
  readonly type = 'HunterAI';

  constructor(
    public targetingRange: number = 300,
    public pursuitSpeed: number = 1.0,
    public lastTargetUpdate: number = 0
  ) {}
}